import { render, staticRenderFns } from "./LangSwitcherDropdown.vue?vue&type=template&id=172e432b&scoped=true&lang=pug&"
import script from "./LangSwitcherDropdown.vue?vue&type=script&lang=js&"
export * from "./LangSwitcherDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LangSwitcherDropdown.vue?vue&type=style&index=0&id=172e432b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e432b",
  null
  
)

export default component.exports